import { useLayoutEffect, useState } from "react";

export const useXpropsSelectedInstrument = () => {
    const [selectedInstrument, setSelectedInstrument] = useState(null);
    useLayoutEffect(() => {
        setSelectedInstrument(window.xprops?.selectedInstrument);
    }, []);
    return { selectedInstrument };
};